module.exports = __webpack_public_path__ + "img/chan-bg.fde20faa.png";